export enum ToolbarFiltersTypes {
  courses = 'Courses',
  coursesLocal = 'CoursesLocal',
  trainings = 'Trainings',
  trainingsLocal = 'trainingsLocal',
  trainingsEvents = 'TrainingsEvents',
  learningPaths = 'LearningPaths',
  learningPathsLocal = 'LearningPathsLocal',
  courseActivities = 'CourseActivities',
  trainingSchedules = 'TrainingSchedules',
  cohorts = 'Cohorts',
  languages = 'Languages',
  categories = 'Categories',
  courseStatus = 'CourseStatus',
  trainingStatus = 'TrainingStatus',
  type = 'Type',
  author = 'Author',
  mandatory = 'Mandatory',
  members = 'Members',
  memberIdentifiers = 'MemberIdentifiers',
  emailTemplates = 'EmailTemplates',
  emailTemplatesType = 'EmailTemplatesType',
  groups = 'Groups',
  hireDate = 'HireDate',
  onboardingStatus = 'OnboardingStatus',
  userStatus = 'UserStatus',
  searchTable = 'TableSearch',
  checkUserName = 'CheckUserName',
  subunits = 'CheckSubunits',
  editors = 'TrainingEditors',
  trainingAvailability = 'TrainingAvailability',
  trainingTags = 'TrainingTags',
  // Scoped to the current member's accessible trainings — sc-10919.
  trainingTagsUserFacing = 'TrainingTagsUserFacing',
}
